module.exports = __webpack_public_path__ + "img/ico-error.d41d8cd9.svg";